import ArticlePage from "@/pages/article/ArticlePage";

export default function SpotQuality() {
  return <ArticlePage slug="how-to-spot-quality-products" />;
}